export default "__VITE_ASSET__81a51ee1__"